
class AddToCartAnchor extends HTMLElement {
  constructor() {
    super();
    this.isDesktop = window.innerWidth > 1024;
  }

  get realButton() {
    return document.querySelector('[data-add-to-cart]');
  }

  get anchorBuyButton() {
    return this.querySelector('[data-anchor-buy-button]');
  }

  connectedCallback() {
    if (this.isDesktop) return;
    if (!this.realButton || !this.anchorBuyButton) return;

    this.handleScroll = this.handleScroll.bind(this);
    this.handleScroll();

    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      this.handleScroll();
    });

    this.scrollToRealButton = this.scrollToRealButton.bind(this);

    this.initializeEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  initializeEventListeners() {
    window.addEventListener('scroll', this.handleScroll);
    this.anchorBuyButton.addEventListener('click', this.scrollToRealButton);
  }

  removeEventListeners() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.anchorBuyButton) {
      this.anchorBuyButton.removeEventListener('click', this.scrollToRealButton);
    }
  }

  scrollToRealButton() {
    const realButtonRect = this.realButton.getBoundingClientRect();
    const realButtonTopInDocument = realButtonRect.top + window.scrollY;
    const viewportCenter = window.innerHeight / 2;
    const scrollToPosition = realButtonTopInDocument - viewportCenter + (realButtonRect.height / 2);

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth'
    });
  }


  handleScroll() {
const rect = this.realButton.getBoundingClientRect();
  const scrolledPast = rect.bottom < 0; // Entire button is above the viewport
  this.anchorBuyButton.classList.toggle('show', scrolledPast);
  }
}
customElements.define('add-to-cart-anchor', AddToCartAnchor);